import http from '../_helpers/http.service';
import {refreshToken} from '../_helpers';

export const userService = {
    login,
    logout,
    register,
    getAll,
    reenviarActivacion,
    chequearMailExiste,
    chequearUsuarioExiste,
    recuperarPassword,
    cambiarPassword,
    actualizarUsuario,
    getLogueado,
    estaLogueado,
    loginGoogle,
    grabarPushSuscripcion,
    enviarCodigoRegistracion,
    cancelarSuscripcion,
    deleteEquipoFromUsuario,
    cancelarSuscripcionUser,
    traerRoles,
    traerRolesAdmin,
    buscarUsuarios,
    refrescarToken,
    guardarToken,
    grabarAdmin,
    traerInfoGral

};

const apiUrl = process.env.REACT_APP_API_URL;


function traerRolesAdmin() {

    var url = '/api/usuario/traerRolesAdmin';
    return http.get(url);
}

function traerInfoGral() {

    var url = '/perfil/traerInfoGral';
    return http.get(url);
}

function buscarUsuarios(values) {
    var url = '/api/usuarios/buscarUsuarios';
    return http.post(url, JSON.stringify(values));
}

function deleteEquipoFromUsuario(values) {
    var url = '/api/usuario/deleteEquipoFromUsuario';
    return http.post(url, JSON.stringify(values));
}



function guardarToken(user) {
    if (user)
        localStorage.setItem('rumbosUser', JSON.stringify(user));
}


function refrescarToken() {
    const url = apiUrl + '/oauth/access_token?grant_type=refresh_token&refresh_token=' + refreshToken();

    let res = fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrer: 'no-referrer'
    }).then(res => res.json()).then(user => {
        if (user.access_token)
            localStorage.setItem('rumbosUser', JSON.stringify(user));
    });
}

function traerRoles() {
    var url = "/api/usuario/traerRoles";
    return http.get(url)
        .then(data => {
            try {
                let rolesFinal = [];
                data.roles.forEach((element, i1) => {
                    rolesFinal.push(element.authority);
                });
                let user = JSON.parse(localStorage.getItem('rumbosUser'));
                user.roles = rolesFinal;
                localStorage.setItem('rumbosUser', JSON.stringify(user));
            } catch (err) {
                console.warn('err', err);
            }

        });
}


function login(username, password) {
    var url = '/api/login';
    return http.post(url, JSON.stringify({username: username, password: password}))
        .then(user => {
            try {
                localStorage.setItem('rumbosUser', JSON.stringify(user))
                return user;
            } catch (err) {
                console.warn('************************************************err', err);
            }

        });
}

function loginGoogle(gResponse) {
    var url = '/api/login';

    return http.post(url, JSON.stringify({username: '', password: '', gTokenId: gResponse.tokenId}))
        .then(user => {
            localStorage.setItem('rumbosUser', JSON.stringify(user))
            return user;
        });
}

function enviarCodigoRegistracion(mail) {

    var url = '/usuario/enviarCodigoRegistracion';
    return http.post(url, JSON.stringify({mail: mail}));
}

function grabarPushSuscripcion(suscripcion, key, auth) {

    var url = '/api/usuario/grabarPushSuscripcion';
    return http.post(url, JSON.stringify({key: key, auth: auth, endpoint: suscripcion.endpoint}));
}

function estaLogueado() {
    const user = localStorage.getItem('rumbosUser')
    return user !== null;
}

function logout() {
    localStorage.removeItem('userLogged');
    localStorage.removeItem('rumbosUser');
}

function getAll() {

    var url = '/api/usuarios/todos';
    return http.get(url);
}

function getLogueado() {

    var url = '/api/usuario/';
    return http.get(url);
}

function grabarAdmin(user) {
    var url = '/api/usuario/grabarAdmin';
    return http.post(url, JSON.stringify(user));
}

function register(user) {
    var url = '/usuario/registrar';
    return http.post(url, JSON.stringify(user));
}

function cancelarSuscripcion(values) {
    var url = '/api/ventas/cancelarSuscripcion';
    return http.post(url, JSON.stringify(values));
}


function cancelarSuscripcionUser() {
    var url = '/api/ventas/cancelarSuscripcionUser';
    return http.get(url);
}


function actualizarUsuario(users) {
    var url = '/api/usuario/actualizar';
    return http.post(url, JSON.stringify(users));
}

function reenviarActivacion(codigo) {
    var jCodigo = {codigo: codigo};
    var url = '/usuario/reenviarActivacion';

    return http.post(url, JSON.stringify(jCodigo));
}

function chequearMailExiste(mail) {
    var jCodigo = {mail: mail};
    var url = '/usuario/chequearMailExiste';
    return http.post(url, JSON.stringify(jCodigo));
}

function chequearUsuarioExiste(mail) {
    var jCodigo = {mail: mail};
    var url = '/usuario/chequearUsuarioExiste';
    return http.post(url, JSON.stringify(jCodigo));
}

function recuperarPassword(mail) {
    var jCodigo = {mail: mail};
    var url = '/usuario/recuperarPassword';
    return http.post(url, JSON.stringify(jCodigo));
}

function cambiarPassword(values) {

    var url = values.esRecuperacion ? '/usuario/cambiarPassword' : '/api/usuario/cambiarPassword';
    return http.post(url, JSON.stringify(values));
}
